import { useFormikContext } from "formik";

export default function AdditionalField({ component, equalName, equalValue }) {
  const { values } = useFormikContext();

  if (values[equalName] !== equalValue) return null;

  return component;
}
